
import Vue from "vue";
import { Dossier } from "../../models/dossier/dossier";
import { DossierService } from "../../services/dossier-service";
import { AuthService } from "../../services/auth-service";
export default Vue.extend({
	data(){
		return {
			dossiers: [] as Dossier[]
		};
	},
	computed: {
		canCreateDossier():boolean {
			if (!AuthService.wfCompany){
				return false;
			}
			if (AuthService.wfCompany.getMaxExtraDossiersCount() + 1 <= this.dossiers.length){
				return false;
			}
			return true;
		},
		maxDossiers():number{
			return AuthService.wfCompany.getMaxExtraDossiersCount() + 1;
		}
	},
	methods: {
		addDossier(){
			this.$router.push("/settings/company/dossier/new");
		},
		editDossier(dossier:Dossier){
			this.$router.push(`/settings/company/dossier/${dossier.id}`);
		}
	},
	async created(){
		this.dossiers = await DossierService.getDossiers();
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
